import React from 'react';
import classNames from 'classnames';
// constants
import { prefix } from '../../../../constants';
export const SettingsPanel = ({ className, children }) => {
    return React.createElement("div", { className: classNames(className, `${prefix}-settings-panel`) }, children);
};
//# sourceMappingURL=SettingsPanel.js.map